import { useEffect, useState } from "react";
import { useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import Sidebar from "../../components/Sidebar";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import getQrSigningUrl from "../../components/SigningUrls";
import API_URL from "../../api/API";

const BusinessSmartTemplateStep8 = () => {
  const { waiverId } = useParams();
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();

  const [waiver, setWaiver] = useState(null);
  const [locations, setLocations] = useState([]);

  const qrRefs = useRef({});

  useEffect(() => {
    if (!business) {
      navigate("/business/login");
      return;
    }

    const load = async () => {
      // get waiver
      const res = await fetch(
        `${API_URL.BUSINESS_WAIVER_BY_ID}/${waiverId}`,
        {
          headers: {
            Authorization: `Bearer ${business.token}`,
          },
        }
      );
      const data = await res.json();
      setWaiver(data.waiver);

      // get all locations
      const locRes = await fetch(API_URL.BUSINESS_LOCATIONS, {
        headers: {
          Authorization: `Bearer ${business.token}`,
        },
      });
      const locJson = await locRes.json();

      /*const waiverLocations = locJson.locations.filter((l) =>
        data.waiver.locations.includes(l._id)
      );*/

      const allWaivers = data.siblingWaivers || [data.waiver];
      const waiverLocations = allWaivers.map((w) => {
        const locationId = typeof w.locations[0] === "object"
          ? w.locations[0]._id
          : w.locations[0];

        const loc = locJson.locations.find((l) => l._id === locationId);

        return {
          ...loc,
          uniqueSlug: loc.uniqueSlug,
          waiver: w,
        };
      });

      setLocations(waiverLocations);
    };

    load();
  }, [business, waiverId, navigate]);

  if (!waiver) return <div>Loading...</div>;

  const origin = window.location.origin;

  const getId = (v) => (typeof v === "object" ? v?._id : v);

  /*const buildUrl = (locationId) =>
  `${origin}/start_waiver?b=${getId(waiver.businessId)}&bt=${getId(
    waiver.businessTypeId
  )}&s=${getId(waiver.serviceId)}&l=${locationId}`;*/

  /*const buildUrl = (w, locationId) =>
  `${origin}/start_waiver?b=${getId(w.businessId)}&bt=${getId(
    w.businessTypeId
  )}&s=${getId(w.serviceId)}&l=${locationId}`;*/
  

  const buildUrl = (w, locationUniqueSlug) =>
    `${origin}/start-waiver/${
      locationUniqueSlug
    }/${
      w.businessTypeId.uniqueSlug
    }/${
      w.service.uniqueSlug
    }`;



  const downloadSVG = (id) => {
    const svg = document.getElementById(`qr-${id}`);
    if (!svg) return;

    const serializer = new XMLSerializer();
    const source = serializer.serializeToString(svg);

    const blob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `qr-${id}.svg`;
    link.click();

    URL.revokeObjectURL(url);
  };

  const printSVG = (id) => {
    const svg = document.getElementById(`qr-${id}`);
    if (!svg) return;

    const serializer = new XMLSerializer();
    const source = serializer.serializeToString(svg);

    const w = window.open("");
    w.document.write(source);
    w.document.close();
    w.print();
  };

  const copyLink = async (url) => {
    await navigator.clipboard.writeText(url);
    alert("Link copied to clipboard");
  };
  

  return (
    <div className="h-screen flex bg-background">
      <Sidebar />

      <div className="flex-1 overflow-auto py-10">
        <div className="max-w-4xl mx-auto px-6">

          <h1 className="text-2xl font-semibold text-center mb-2">
            Your waiver is live
          </h1>
          <p className="text-center text-muted-foreground mb-10">
            Your waiver is live and ready to collect signatures.
          </p>

          {locations.map((loc) => {
            //const url = buildUrl(loc._id);
           // const url = buildUrl(loc.waiver, loc._id);


            
            // Ordinary URL for sharing with customers
            const signingUrl = buildUrl(loc.waiver, loc.uniqueSlug);

            // QR URL identifies the signing channel as QR
            const qrSigningUrl = getQrSigningUrl(signingUrl);

            return (
              <div
                key={loc._id}
                className="bg-white shadow-md rounded-2xl p-10 mb-14"
              >
                <h2 className="text-center text-xl font-semibold mb-6">
                  {loc.name}
                </h2>

                <p className="text-center text-sm text-gray-500 mb-4">
                  Scan to Sign
                </p>

                <div className="flex justify-center mb-8">
                  <div className="p-6 border-4 rounded-3xl">
                    <QRCodeSVG
                      id={`qr-${loc._id}`}
                      value={qrSigningUrl}
                      size={220}
                      includeMargin
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex justify-center gap-6 mb-10">
                  <button
                    onClick={() => downloadSVG(loc._id)}
                    className="px-8 py-3 rounded-full bg-yellow-500 hover:bg-yellow-600 text-black font-medium"
                  >
                    ⬇ Download QR
                  </button>

                  <button
                    onClick={() => printSVG(loc._id)}
                    className="px-8 py-3 rounded-full border font-medium"
                  >
                    🖨 Print QR
                  </button>
                </div>

                {/* Share link card */}
                <div className="bg-gray-50 border rounded-xl p-6">
                  <div className="flex items-start gap-4 mb-3">
                    <div className="bg-blue-100 p-2 rounded-lg">🔗</div>
                    <div>
                      <p className="font-medium">Share signing link</p>
                      <p className="text-sm text-gray-500">
                        Copy and send to your clients
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between bg-white border rounded-lg px-4 py-3">
                    <span className="text-sm text-gray-600 break-all pr-4">
                      {signingUrl}
                    </span>

                    <button
                      onClick={() => copyLink(signingUrl)}
                      className="text-sm font-medium"
                    >
                      Copy Link
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BusinessSmartTemplateStep8;